import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from '../app.models';
import { routerTypesFeatureKey, RouterTypesState } from './router-types.models';
import { createIsEqualSelector } from '../shared/ngrx/selector.utils';

const selectFeature = createFeatureSelector<RouterTypesState>(routerTypesFeatureKey);

export const selectLoading = createSelector(selectFeature, (state) => state.loading > 0);

export const selectRouterTypes = createIsEqualSelector(selectFeature, (state: RouterTypesState) => state.routerTypes);
export const selectInitiallyLoaded = createSelector(selectFeature, (state) => state.initiallyLoaded);
